import React, { useRef } from "react";

const ContactForm = () => {
  const nameRef: any = useRef();
  const emailRef: any = useRef();
  const subjectRef: any = useRef();
  const messageRef: any = useRef();

  const handleSend = () => {
    const name = nameRef.current.value;
    const email = emailRef.current.value;
    const subject = subjectRef.current.value;
    const message = messageRef.current.value;

    const mailtoLink = `mailto:damietta@zahrantravel.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(
      `الاسم: ${name}\nالبريد الإلكتروني: ${email}\n\n${message}`
    )}`;

    window.location.href = mailtoLink;
  };

  return (
    <form className="ml-auto space-y-4" onSubmit={(e) => e.preventDefault()}>
      <input
        type="text"
        placeholder="الاسم"
        ref={nameRef}
        className="w-full text-gray-800 rounded-md py-2.5 px-4 border text-sm outline-blue-500"
      />
      <input
        type="email"
        placeholder="البريد الإلكتروني"
        ref={emailRef}
        className="w-full text-gray-800 rounded-md py-2.5 px-4 border text-sm outline-blue-500"
      />
      <input
        type="text"
        placeholder="الموضوع"
        ref={subjectRef}
        className="w-full text-gray-800 rounded-md py-2.5 px-4 border text-sm outline-blue-500"
      />
      <textarea
        placeholder="الرسالة"
        rows={6}
        ref={messageRef}
        className="w-full text-gray-800 rounded-md px-4 border text-sm pt-2.5 outline-blue-500"
      ></textarea>
      <button
        type="button"
        onClick={handleSend}
        className="text-white bg-blue-500 hover:bg-blue-600 rounded-md text-sm px-4 py-3 w-full !mt-6"
      >
        إرسال
      </button>
    </form>
  );
};

export default ContactForm;
